import gsap from 'gsap'
import { q1O, q1I } from '../util/nE'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import SplitText from 'gsap/SplitText'
gsap.registerPlugin(MotionPathPlugin, SplitText)

class CircularList {
  constructor ($el) {
    this.el = $el
    this.segments = this.el.querySelectorAll('.circular-list__segment')
    this.centerTitle = this.el.querySelector('.circular-list__center-title')
    this.centerText = this.el.querySelector('.circular-list__center-text')
    this.activeSegment = null
    this.accordionItems = this.el.querySelectorAll('.accordion__item')
  }

  init () {
    this.buildAnimations()
    this.bindEvents()
    this.buildAccordion()
  }

  buildAnimations () {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        ease: (t) => {
          return q1O(t)
        },
        duration: 1.2,
      },
    })

    tl.fromTo(this.el, { autoAlpha: 0, y: 100 }, { autoAlpha: 1, y: 0 })
  }

  bindEvents () {
    this.segments.forEach((segment) => {
      segment.addEventListener('click', () => {
        if (this.activeSegment) {
          this.activeSegment.classList.remove('is-active')
          gsap.set(this.activeSegment, { zIndex: 1 })
        }

        segment.classList.add('is-active')
        this.activeSegment = segment

        // Move the active segment to the end of its parent container to ensure it's rendered on top of all other segments
        const parent = segment.parentNode
        parent.removeChild(segment)
        parent.appendChild(segment)

        this.updateCenterContent(segment)
      })
    })
  }

  updateCenterContent (segment) {
    const title = segment.getAttribute('data-title')
    const content = segment.getAttribute('data-content')

    const tl = gsap.timeline()

    tl.to([this.centerTitle, this.centerText], {
      autoAlpha: 0,
      y: -20,
      duration: 0.4,
      ease: (t) => {
        return q1I(t)
      },
    })

    tl.add(() => {
      this.centerTitle.textContent = title
      this.centerText.innerHTML = content
    })

    tl.to([this.centerTitle, this.centerText], {
      autoAlpha: 1,
      y: 0,
      duration: 0.6,
      ease: (t) => {
        return q1O(t)
      },
      stagger: 0.1,
    })
  }

  buildAccordion () {
    this.accordionItems.forEach(item => {
      const toggleButton = item.querySelector('.accordion__toggle')
      const content = item.querySelector('.accordion__content')

      toggleButton.addEventListener('click', () => {
        const isActive = item.classList.contains('is-active')

        const currentAnimation = gsap.getTweensOf(content)

        if (currentAnimation.length && currentAnimation[0].isActive()) {
          return
        }

        if (isActive) {
          item.classList.remove('is-active')
          gsap.to(content, {
            height: 0,
            duration: 0.7,
            ease: (t) => {
              return q1O(t)
            },
          })
        } else {
          item.classList.add('is-active')
          gsap.to(content, {
            height: 'auto',
            duration: 0.7,
            ease: (t) => {
              return q1O(t)
            },
          })
        }
      })
    })
  }

  destroy () {
  }
}

export default CircularList



//////////////////
// WEBPACK FOOTER
// ./scripts/components/CircularList.js
// module id = 29
// module chunks = 0